export default function FloatingContact() {
  return (
    <div
      className="fixed z-[80] right-4 bottom-4 flex flex-col gap-3"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {/* WhatsApp */}
      <a
        href="https://wa.me/40763536451?text=Bună!+Aș+dori+o+programare+la+TytyStyle."
        target="_blank"
        rel="noreferrer"
        aria-label="Scrie pe WhatsApp"
        className="
          bg-green-500 text-white shadow-lg hover:opacity-90
          rounded-full
          w-14 h-14 p-0 flex items-center justify-center   /* mobile: circle icon */
          sm:w-auto sm:h-auto sm:px-5 sm:py-3 sm:gap-2     /* desktop: pill with text */
        "
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20 3.5A10 10 0 0 0 4.7 19.3L3 21l1.8-.6A10 10 0 1 0 20 3.5Zm-8 17a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-2.5.8.8-2.4-.2-.3a8.2 8.2 0 1 1 12.7-6.8 8.1 8.1 0 0 1-8.3 8.1Zm4.6-5c-.2-.1-1.3-.6-1.5-.7s-.4-.1-.6.1-.7.7-.8.8-.3.1-.5 0a6.8 6.8 0 0 1-2-1.2 7.5 7.5 0 0 1-1.4-1.8c-.1-.2 0-.4.1-.5l.4-.5.2-.5v-.3c0-.2-.1-.4-.2-.5-.1-.2-.6-1.5-.8-2S9 6.8 8.8 6.8h-.5a1 1 0 0 0-.8.4c-.3.4-1 1-1 2.5s1 2.9 1.1 3.1a10.7 10.7 0 0 0 3.9 4c.5.3 1 .5 1.4.7.6.2 1.1.2 1.5.1s1-.4 1.1-.8.6-1 .7-1.2-.1-.5-.3-.6Z"/>
        </svg>
        <span className="hidden sm:inline font-semibold">WhatsApp</span>
      </a>

      {/* Phone */}
      <a
        href="tel:+40763536451"
        aria-label="Sună acum"
        className="
          bg-black text-white hover:bg-gray-900 shadow-lg
          rounded-full
          w-14 h-14 p-0 flex items-center justify-center   /* mobile: circle icon */
          sm:w-auto sm:h-auto sm:px-5 sm:py-3              /* desktop: pill with text */
          sm:gap-2 text-sm font-semibold
        "
      >
        {/* phone icon */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M6.6 10.8a15.7 15.7 0 0 0 6.6 6.6l2.2-2.2a1.1 1.1 0 0 1 1.1-.28c1.2.4 2.5.62 3.8.62a1.1 1.1 0 0 1 1.1 1.1V20a2 2 0 0 1-2 2C9.6 22 2 14.4 2 5a2 2 0 0 1 2-2h3.34c.6 0 1.08.47 1.1 1.06 0 1.3.22 2.6.62 3.8.13.37.04.78-.24 1.06L6.6 10.8z"/>
        </svg>
        <span className="hidden sm:inline">Sună acum</span>
      </a>
    </div>
  );
}
